import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useTranslation } from '@common/hooks/translation';
import { Providers } from './components/providers';
import { Search } from './components/serach';
import { GamesList } from './components/gameList';
import { GameDetails } from './components/gameDetails';
import { Categories } from './components/categories';

import './style.scss';

const CasinoAndLiveCasinoViewer = ({
  categories,
  providers,
  categoryId,
  selectedProviders,
  toggleProvider,
  selectCategory,
  gameId,
  gamesData,
  loadGames,
  onSearchChange,
  searchValue,
  routePath,
  removeHeader,
  removeCategories,
  removeSearch,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [providerExpanded, setProiderExpanded] = useState(false);
  const t = useTranslation();
  const className = classnames('', {
    'casino-main-container': routePath.includes('/casino'),
    'liveCasino-main-container': routePath.includes('/liveCasino'),
    'casino-provider': routePath.includes('casino-provider'),
    'casino-category': routePath.includes('casino-category'),
  });

  const content = (
    <div className={className}>
      <div className="main-wrapper-casino">
        <div className={(!removeHeader && categoryId !== 'lastPlayed') ? 'head-row-holder' : 'hide-serach-and-providers'}>
          {providerExpanded && <div className="provider-header">{t('Providers')}</div>}
          <Providers
            setProiderExpanded={setProiderExpanded}
            providerExpanded={providerExpanded}
            providers={providers}
            selectedProviders={selectedProviders}
            toggleProvider={toggleProvider}
          />
          {!gameId && !removeSearch && (
            <Search
              providerExpanded={providerExpanded}
              onSearchChange={onSearchChange}
              searchValue={searchValue}
            />
          )}
        </div>
        <div className="casino-game-wrappers">
          {gameId ? (
            <GameDetails
              routePath={routePath}
              id={gameId}
              isFullScreenGame
            />
          ) : (
            <GamesList
              routePath={routePath}
              gamesData={gamesData}
              loadGames={loadGames}
              categoryId={categoryId}
            />
          )}
        </div>
      </div>
    </div>
  );

  if (routePath.includes('casino-provider')) return content;

  return (
    <div className="casino-wrapper">
      {
        (!removeHeader && categoryId !== 28 && !removeCategories) ? (
          <div className={`casino-left-side ${isExpanded ? 'active' : ''}`}>
            <Categories
              categories={categories}
              categoryId={categoryId}
              selectCategory={selectCategory}
              isExpanded={isExpanded}
              setIsExpanded={setIsExpanded}
            />
          </div>
        ) : null
      }
      {content}
    </div>
  );
};
CasinoAndLiveCasinoViewer.propTypes = {
  categories: PropTypes.array,
  providers: PropTypes.array,
  categoryId: PropTypes.number,
  selectedProviders: PropTypes.array,
  toggleProvider: PropTypes.func,
  selectCategory: PropTypes.func,
  gameId: PropTypes.number,
  gamesData: PropTypes.object,
  loadGames: PropTypes.func,
  onSearchChange: PropTypes.func,
  searchValue: PropTypes.string,
  routePath: PropTypes.string,
  removeHeader: PropTypes.bool,
  removeCategories: PropTypes.bool,
  removeSearch: PropTypes.bool,
};
export default CasinoAndLiveCasinoViewer;
